/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

export type Settlements = {
  primaryId?: string;
  chefId: string;
  name: string;
  categoryId: string;
  isAdmin: any;
  typeId: string;
  cuisineId: string;
  mrpPrice: string;
  discountValue: string;
  offerPrice: string;
  description: string;
  ingredients: string;
  dishImage: string | null;
  tags: string;
  enableDisableStatus: any;
  brandName:string
  createdBy: number;
  addons: [
    {
      name: string;
      quantity: string;
      price: string;
    }
  ];
  extraaddons: [
    {
      name: string;
      quantity: number;
      price: number;
    }
  ];
  message?: string;
  status?: string;
};
export const initialSettlements: Settlements = {
  name: "",
  isAdmin: "",
  categoryId: "",
  chefId: "",
  typeId: "",
  cuisineId: "",
  mrpPrice: "",
  discountValue: "",
  offerPrice: "",
  description: "",
  ingredients: "",
  dishImage: "",
  tags: "",
  enableDisableStatus: "",
  brandName:"",
  createdBy: 1,
  addons: [
    {
      name: "",
      quantity: "",
      price: "",
    },
  ],
  extraaddons: [
    {
      name: "",
      quantity: 0,
      price: 0,
    },
  ],
};
export type Cerificate = {
  primaryId: string;
  chef_id?: any;
  name?: string;
  description?: string;
  created_by: number;
  updated_by: number;
  status?: number;
  message?: string;
  certificate?: any; // Add this line to define the certificate field
};
export const initialValues: Cerificate = {
  primaryId:"",
  name: "",
  chef_id: "",
  description: "",
  certificate: "",
  status: 0,
  created_by: 0,
  updated_by: 0,
};
